<template>
  <div class="container container-table loginpage">
    <div class="row vertical-10p logincntrrow">
      <div class="container logincntr">
        <div class="text-center col-md-4 col-sm-offset-4 loginFormwrp">
          <img src="/static/img/d2dvoyager-logo.png" class="center-block logina-logo">
          <div class="confirm forcechange">
            <h2>Forget Password</h2>
             <div class="error loginModuleToperror"><span class="error " v-show="errors.has('username')">{{ errors.first('username') }}</span></div>

            <form @submit.prevent="confirm">
              <div class="form-forgetpassword">
                <div class="input-group" v-bind:class="errors.has('username') ? 'error' : ''">
                  <span class="input-group-addon">
                    <i class="fa fa-user"></i>
                  </span>
                  <input class="form-control" type="text" placeholder="User Name" v-model="username" v-on:blur="validemail" name="username" v-validate="{ email: true }" required>
                </div>
                <div class="input-group forgetsubmit">
                  <span>If you are facing a issue, contact support on Yammer Group</span>
                  <button type="submit" v-bind:class="'loginsubmit btn btn-primary btn-lg'">GO</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
const config = {
  errorBagName: 'errors', // change if property conflicts.
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'en',
  dictionary: null,
  strict: true,
  enableAutoClasses: true,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'input|blur|change',
  inject: true
}

Vue.use(VeeValidate, config)
export default {
  name: 'Confirm',
  data () {
    return {
      username: ''
    }
  },
  methods: {
    validemail () {
      this.$validator.validate('username', this.username)
      if (this.fields.username.valid) {
        var emailCorrecter = String(this.username)
        emailCorrecter = emailCorrecter.split('.')[0].charAt(0).toUpperCase() + emailCorrecter.split('.')[0].slice(1) + '.' + emailCorrecter.split('.')[1].charAt(0).toUpperCase() + emailCorrecter.split('.')[1].slice(1) + '.' + emailCorrecter.split('.')[2]
        this.username = emailCorrecter
      }
    },
    confirm () {
      this.$cognito.forgotPassword(this.username)
        .then(result => {
          this.$router.replace('/passwordreset')
        })
        .then(err => {
          this.error = err
        })
    }
  }
}
</script>
<style scoped>
.input-group.forgetsubmit {
  position: absolute;
  top: 0px;
  right: 0px;
}
.form-forgetpassword {
  position: relative;
}
.forcechange h2 {
  color: #444;
  text-align: center;
  margin-bottom: 20px;
  font-size: 20px;
  margin-top: 0px;
}
.container.logincntr {
  height: 210px;
}
</style>



// WEBPACK FOOTER //
// ForgotPassword.vue?0ec0f4f9